import { Injectable } from '@angular/core';
import {
  GetAllLabelType,
  GetPriceLevelData,
  GetProductsById,
} from './print-label-modal';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PrintLabelModalService {
  constructor(private http: HttpClient) {}

  public getProductById(id: string) {
    return this.http.get<GetProductsById[]>(
      `SalesOrder/GetProductByOrderId/${id}`
    );
  }

  public getPriceLevelData() {
    const url: string = 'PriceLevel/GetAllSalesRepsPriceLevel';
    return this.http.get<GetPriceLevelData[]>(url);
  }

  public getAllLabelTypes() {
    const url: string = 'LableTypes/GetAllSalesOrderLablelType';
    return this.http.get<GetAllLabelType[]>(url);
  }
}
